const workerTypes = ["CNA", "LVN", "RN", "NP"];

const workerTypeObj = {
  CNA: "CNA",
  LVN: "LVN",
  RN: "RN",
  NP: "NP",
  PACU_RN: "PACU RN",
  OR_RN: "OR RN",
  SPD_TECH: "SPD TECH",
  SURG_TECH: "SURG TECH",
  CRNA: "CRNA",
  PHLEBOTOMIST: "Phlebotomist",
  MLT: "MLT",
  MEDICAL_ASSISTANT: "Medical Assistant",
  PT: "PT",
  PTA: "PTA",
  HHA: "HHA",
  NON_CLINICAL: "Non Clinical",
  SITE_LEAD: "Site Lead",
  NURSE: "NURSE",
};

const allWorkerTypes = Object.values(workerTypeObj);

const workerTypeDefaults = workerTypes.reduce((acc, type) => ({ ...acc, [type]: 0 }), {});

const workerTypeModel = workerTypes.reduce(
  (acc, type) => ({ ...acc, [type]: { type: Number, default: 0 } }),
  {}
);

export { workerTypes, workerTypeDefaults, workerTypeModel, allWorkerTypes, workerTypeObj };
